import Action from "../actions";

export function adsManagementReducer(state ={
  viewList: {
    adsList: [],
    total: 0,
  },
  addNew: {
    isValid: false,
    isChecked: true
  },
  adsDetail: {}
}, action) {
  if (action.type === Action.SET_ADS_MANAGEMENT) {
    return action.data
  }
  return state;
}